'use client';

import _slicedToArray from "/codebuild/output/src2858/src/s3/01/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
function cssVariablesObjectToString(variables) {
  return Object.entries(variables).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      name = _ref2[0],
      value = _ref2[1];
    return "".concat(name, ": ").concat(value, ";");
  }).join("");
}
export { cssVariablesObjectToString };